import { useEffect, useState, useRef } from "react";

import jBox from "jbox";
import $ from "jquery";
import QRCode from "qrcode.react";

import img_icoClose from "../../assets/img/ui/menu/ico-close.svg";

const ModalPartnerQRCode = ({
  open = false,
  onClose = () => {},
  custFullname = "",
  custId = "",
}) => {
  const [modal, setModal] = useState(null);
  const [inviteUrl, setInviteUrl] = useState("");
  const [qrCodeSrc, setQrCodeSrc] = useState("");
  const qrCodeRef = useRef(null);

  const openModal = () => {
    modal.open();
  };

  const closeModal = () => {
    modal.close();
    onClose();
  };

  const listenerCloseModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModal");
    btnCloseModal.addEventListener("click", () => {
      closeModal();
    });
  };

  /* First event render */
  useEffect(() => {
    const initModal = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalQrCode"),
    });
    setModal(initModal);

    return () => {
      initModal.destroy();
    };
  }, []);
  /* End First event render */

  useEffect(() => {
    // console.log("modalQrCode useEffect2!! >>", modalQrCode, open);

    if (modal && open) {
      openModal();
      listenerCloseModal();
      // setTimeout(() => listenerCloseModal(), 100)
    }
  }, [modal, open]);

  // Set inviteUrl when custId is available
  useEffect(() => {
    if (custId) {
      console.log("REACT_APP_LIFF_URL >>>", process.env.REACT_APP_LIFF_URL);
      const baseUrl = process.env.REACT_APP_LIFF_URL || "https://liff.line.me/2003492104-xobk5E4M";
      const url = `${baseUrl}/partner/invite/${custId}`;
      // console.log("custId >>>", custId);
      // console.log("baseUrl >>>", baseUrl);
      // console.log("url >>>", url);

      setInviteUrl(url);
    } else {
      setInviteUrl("");
      setQrCodeSrc("");
    }
  }, [custId]);

  // Generate QR code image when inviteUrl and ref are available
  useEffect(() => {
    if (inviteUrl && qrCodeRef.current) {
      // Wait for canvas to render
      const timer = setTimeout(() => {
        const canvas = qrCodeRef.current.querySelector("canvas");
        if (canvas) {
          const dataUrl = canvas.toDataURL("image/png");
          setQrCodeSrc(dataUrl);
        }
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setQrCodeSrc("");
    }
  }, [inviteUrl]);

  // useEffect(() => {
  //   console.log("inviteUrl >>>", inviteUrl);
  // }, [inviteUrl]);

  return (
    <div className="bModal bCard" id="ModalQrCode">
      <div className="btnIconClose btnCloseModal" id="btnCloseModal">
        <img src={img_icoClose} alt="close" />
      </div>
      <div className="bInner">
        <div className="bQr">
          <h2>เชิญชวนพาร์ทเนอร์ผ่านการสแกน QR Code</h2>
          <div className="bImg">
            {custId && inviteUrl !== "" && (
              <div ref={qrCodeRef} style={{ display: "none" }}>
                <QRCode value={inviteUrl} size={160} renderAs="canvas" />
              </div>
            )}
            <img
              src={qrCodeSrc || "https://dummyimage.com/160x160/000/fff"}
              alt="qrcode"
            />
          </div>
        </div>
        <div className="bDetail">
          <p>{custFullname}</p>
          <p className="detail">ID: {custId}</p>
        </div>
      </div>
    </div>
  );
};

export default ModalPartnerQRCode;
